import { Button, Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "./language-switcher";

export const LanguageSwitcherButton = () => {
  const { i18n, t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal}>{i18n.language}</Button>
      <Modal
        title={t("language.title")}
        footer={false}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <LanguageSwitcher />
      </Modal>
    </>
  );
};
